import PropTypes from 'prop-types';

import BaseSelectorReadonlyToInput from "../Select/BaseSelectorReadonlyToInput";
import AssetService from "../../services/AssetService";

class BarcodeSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      filterParamName : 'internalBarcode.code',
      defaultValue: props.defaultValue && props.defaultValue.map(
          x => ({'internalBarcode.code': x.internalBarcode && x.internalBarcode.code, ...x})),
      title: props.title || 'Produto/Ativo',
      label: 'internalBarcode.code',
      url: AssetService.ALL_INTERNAL_BARCODES_URL,
      placeholder: props.placeholder,
      style: props.style
    };
  }
}

BarcodeSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
  multiple: PropTypes.bool,
  placeholder: PropTypes.string
};

export default BarcodeSelector;



// WEBPACK FOOTER //
// ./src/component/Barcode/BarcodeSelector.js